import lodash from 'lodash';

export const reduxSetter = (state, data) => {
    const ignoreValueAsFn = Boolean(data.ignoreValueAsFn);
    let stateChanged = false;

    if (lodash.isPlainObject(data.payload)) {
        // eslint-disable-next-line no-restricted-syntax
        for (const path in data.payload) {
            if (Reflect.has(data.payload, path)) {
                const value = data.payload[path];

                if (!ignoreValueAsFn && lodash.isFunction(value)) {
                    const oldValue = lodash.get(state, path);
                    const newValue = value(state, oldValue);

                    if (oldValue !== newValue) {
                        stateChanged = true;
                        lodash.set(state, path, newValue);
                    }
                } else if (lodash.get(state, path) !== value) {
                    stateChanged = true;
                    lodash.set(state, path, value);
                }
            }
        }
    } else if (lodash.isString(data.path)) {
        if (!ignoreValueAsFn && lodash.isFunction(data.value)) {
            const oldValue = lodash.get(state, data.path);
            const newValue = data.value(state, oldValue);

            if (oldValue !== newValue) {
                stateChanged = true;
                lodash.set(state, data.path, newValue);
            }
        } else if (lodash.get(state, data.path) !== data.value) {
            stateChanged = true;
            lodash.set(state, data.path, data.value);
        }
    }

    const refreshPaths = lodash.isString(data.refreshPaths) ? [data.refreshPaths] : data.refreshPaths;

    if (stateChanged && lodash.isArray(refreshPaths)) {
        refreshPaths.forEach((path) => {
            const oldValue = lodash.get(state, path);
            let newValue;

            if (lodash.isArray(oldValue)) {
                newValue = [...oldValue];
            } else if (lodash.isPlainObject(oldValue)) {
                newValue = { ...oldValue };
            }

            if (newValue) {
                lodash.set(state, path, newValue);
            }
        });
    }

    return stateChanged ? { ...state } : state;
};



// WEBPACK FOOTER //
// ./src/utils/reduxSetter.js